"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExternalInputNew = exports.ExternalInputResultData = void 0;
const tslib_1 = require("tslib");
const Utilities_1 = require("../../../javascript/Utilities");
const MethodServerResponse_1 = require("../../../model/MethodServerResponse");
const Base_1 = require("../../../model/Base");
let inputWindowMarkup = require("../../../templates/externalInputs/ExternalInputWindowNew.tmpl.html");
class ExternalInputResultData {
    constructor() {
        this.errorCode = 0;
    }
}
exports.ExternalInputResultData = ExternalInputResultData;
/**
* Base class for all external inputs
*/
class ExternalInputNew {
    //#endregion Window management properties
    /**
    * Creates a new ExternalInput
    */
    constructor(controlColl, currentInstance, methodName) {
        this.controlColl = controlColl;
        this.methodName = methodName;
        /**
        * True if the external input needs to query configuration parameters from the server.
        * It does so by calling its menuentey with action=config in the parameters map
        */
        this.needServerConfig = false;
        /**
        * True if the external input needs to query configuration parameters from the server.
        * It does so by calling its menuentey with action=config in the parameters map.
        * See getExternInputParams() for details.
        */
        this.serverConfig = {};
        /**
        * Width of the window. Can be overridden in the constructor
        */
        this.windowWidth = 600;
        /**
        * Height of the window. Can be overridden in the constructor
        */
        this.windowHeight = 400;
        /**
        * Action buttons the window. If overridden the external input has to implement the custom action (i.e. resizing on maximization)
        */
        this.windowActions = ["Close"];
        /**
        * Whether the current external input supports multiple selection
        */
        this.multiValue = false;
        /**
        * Wheter the created window is resizable
        */
        this.windowResizeable = false;
        this.title = controlColl.Input.field.fieldTitle;
        this.forceRefreshOnOk = false;
        if (!this.title)
            this.title = controlColl.Input.field.fieldName;
        this.input = this.controlColl.Input;
        this.typeId = this.input.typeId;
        this.mode = this.input.mode;
        this.controlKey = this.input.key;
        this.multiValue = (this.input.field.multiValue) && (this.mode !== Base_1.PropertyPageMode.Search);
        this.currentInstance = currentInstance.clone();
    }
    get left() {
        let that = this;
        let dialog = that.windowData.windowDiv.data("kendoWindow");
        return dialog.options.position.left;
    }
    set left(value) {
        let that = this;
        let dialog = that.windowData.windowDiv.data("kendoWindow");
        dialog.setOptions({
            position: { left: value, top: that.top },
        });
    }
    get top() {
        let that = this;
        let dialog = that.windowData.windowDiv.data("kendoWindow");
        return dialog.options.position.top;
    }
    set top(value) {
        let that = this;
        let dialog = that.windowData.windowDiv.data("kendoWindow");
        dialog.setOptions({
            position: { left: that.left, top: value },
        });
    }
    get height() {
        let that = this;
        let dialog = that.windowData.windowDiv.data("kendoWindow");
        return dialog.options.height;
    }
    set height(value) {
        let that = this;
        let dialog = that.windowData.windowDiv.data("kendoWindow");
        dialog.setOptions({
            height: value,
        });
    }
    get width() {
        let that = this;
        let dialog = that.windowData.windowDiv.data("kendoWindow");
        return dialog.options.width;
    }
    set width(value) {
        let that = this;
        let dialog = that.windowData.windowDiv.data("kendoWindow");
        dialog.setOptions({
            width: value,
        });
    }
    /**
    * Displays the external input window and call back ExternalInputResult when closing
    * @param result Callback method triggered on closing
    */
    show(result) {
        this.callback = result;
        this.initWindowCore();
    }
    center() {
        let that = this;
        that.windowData.windowDiv.data("kendoWindow").center();
    }
    /**
    * Returns the instance that has been changed by the external input
    */
    getUpdatedInstance() {
        let result = new ExternalInputResultData();
        result.instance = this.currentInstance;
        return Promise.resolve(result);
    }
    /**
    * Creates parameter for external input method invocation on the server
    */
    getExternInputParams() {
        let obj = {
            "extvalueinput.multivalue": (this.multiValue ? "Y" : "N"),
            "extvalueinput.pagemode": this.mode.toString(),
            "extvalueinput.fieldname": this.input.field.fieldName,
            "extvalueinput.pagereadonly": (this.mode === Base_1.PropertyPageMode.View ? "Y" : "N"),
            "extvalueinput.readonly": (this.input.readonly ? "Y" : "N")
        };
        if (this.input.field.isFTRepresentativeField)
            obj["extvalueinput.presentedfieldname"] = this.input.field.presentedField;
        return obj;
    }
    /**
    * This is the method in which derived classes render their individual contents
    */
    initWindowContents() {
        return Promise.resolve();
    }
    /**
    * This is the method in which derived classes destroy their individual widgets on close
    */
    destroyWidgets() {
    }
    //#region Private functions
    /**
    * Destroys window along with contained widgets
    */
    destroyWindow() {
        // An dieser Stelle MUSS close aufgerufen werden und nicht destroy, damit der close-event ausgelöst wird
        // (Wird benötigt für IncrementOpenKendoWindowCount/DecrementOpenKendoWindowCount)
        // Im Close-Event wird dann auch this.destroyWidgets(); aufgerufen
        this.windowData.windowDiv.data("kendoWindow").close();
    }
    /**
    * Execute an action for an external input method on the server.
    */
    serverAction(serverAction) {
        let that = this;
        let params = that.getExternInputParams();
        params[that.methodName + "action"] = serverAction.action;
        if (serverAction.customData)
            for (let prop in serverAction.customData)
                if (serverAction.customData.hasOwnProperty(prop))
                    params[that.methodName + prop] = serverAction.customData[prop];
        let inst = serverAction.overrideInstance || that.currentInstance;
        params.instanceData = JSON.stringify([inst.toJSON()]);
        Utilities_1.synUtil.getAJAXData({
            method: "POST",
            url: Utilities_1.synUtil.getWSUrl("InstanceMethod") + that.methodName,
            requestData: JSON.stringify(params),
            done(dataJSON) {
                return tslib_1.__awaiter(this, void 0, void 0, function* () {
                    let data = yield MethodServerResponse_1.MethodServerResponse.fromJSON(dataJSON);
                    serverAction.callBack(data);
                });
            },
            fail(jqXHR, status, errorThrown, url) {
                Utilities_1.synUtil.getAJAXDataFail(jqXHR, status, errorThrown, url);
                if (serverAction.fail)
                    serverAction.fail();
            },
            cleanUp() {
                if (serverAction.cleanUp)
                    serverAction.cleanUp();
            }
        });
    }
    /**
    * Calls the external input menu entry on the server to fetch configuration data
    * @param callBack parameter-less callback method triggered when the server config response has arrived
    */
    initWindowConfig(initCallBack) {
        let that = this;
        if (that.needServerConfig) {
            that.serverAction({
                action: "config",
                customData: {},
                callBack: (data) => {
                    let info = data.additionalInformation;
                    for (let prop in info)
                        if (info.hasOwnProperty(prop))
                            if (prop.indexOf(that.methodName) === 0)
                                that.serverConfig[prop.substring(that.methodName.length)] = info[prop];
                    initCallBack();
                },
                overrideInstance: undefined
            });
        }
        else
            initCallBack();
    }
    /**
    * Creates the main parts of the external input window
    */
    initWindowCore() {
        let that = this;
        that.initWindowConfig(function () {
            that.windowData = Utilities_1.synUtil.popupWindow({
                title: that.title,
                width: that.windowWidth,
                height: that.windowHeight,
                resizable: that.windowResizeable,
                modal: true,
                actions: that.windowActions
            });
            that.windowId = "popup_" + that.windowData.guid;
            that.windowData.windowDiv.css("overflow", "visible");
            if (that.windowContentCssClass)
                that.windowData.contentDiv.addClass(that.windowContentCssClass);
            that.windowData.windowDiv.data("kendoWindow").bind("close", function (e) {
                that.destroyWidgets();
                that.callback(true, undefined, undefined, false);
            });
            let idData = {
                synUtil: Utilities_1.synUtil
            };
            $.each(["ok", "cancel"], function (idx, val) {
                idData[val + "Button"] = val + "Button_" + that.windowData.guid;
            });
            idData.widgetContainer = "widgetContainer_" + that.windowData.guid;
            idData.innerHeight = that.windowData.contentDiv.innerHeight();
            let template = kendo.template(inputWindowMarkup);
            let result = template(idData);
            that.windowData.contentDiv.html(result);
            that.registerOkButton($("#" + idData.okButton));
            that.registerCancelButton($("#" + idData.cancelButton));
            that.widgetContainer = $("#" + idData.widgetContainer);
            if (that.mode === Base_1.PropertyPageMode.View || (that.input && that.input.readonlyForExtInput))
                $("#" + idData.cancelButton).css("display", "none");
            that.initWindowContents().then(() => {
                that.windowData.windowDiv.data("kendoWindow").center();
            });
        });
    }
    setAdditionalData() {
    }
    registerOkButton(buttonJQuery) {
        let that = this;
        buttonJQuery.on("click", function () {
            that.getUpdatedInstance().then((result) => {
                if (result.errorCode === 0) {
                    let readonly = that.mode === Base_1.PropertyPageMode.View || that.input.readonlyForExtInput;
                    if (!readonly)
                        that.setAdditionalData();
                    that.destroyWindow();
                    if (readonly)
                        that.callback(true, undefined, undefined, false);
                    else
                        that.callback(false, result.instance, that.additionalData, that.forceRefreshOnOk);
                }
                else {
                    $.errorDialog({
                        ErrorDisplayMessage: result.errorText
                    });
                }
            });
        });
    }
    enableOkButton(enable) {
        Utilities_1.synUtil.toggleEnabledState($("#okButton_" + this.windowData.guid), enable);
    }
    beginAjax() {
        Utilities_1.synUtil.beginAjaxProgress($("#okButton_" + this.windowData.guid));
        Utilities_1.synUtil.beginAjaxProgress($("#cancelButton_" + this.windowData.guid));
    }
    endAjax() {
        Utilities_1.synUtil.endAjaxProgress($("#okButton_" + this.windowData.guid));
        Utilities_1.synUtil.endAjaxProgress($("#cancelButton_" + this.windowData.guid));
    }
    registerCancelButton(buttonJQuery) {
        let that = this;
        buttonJQuery.on("click", function () {
            that.destroyWindow();
            that.callback(true, undefined, undefined, false);
        });
    }
}
exports.ExternalInputNew = ExternalInputNew;
